import React, { Component } from 'react';
import CountryList from './country-list.jsx';
import caret from '../../images/common-static/icons/ic_caret.svg';
import styles from './country-panel.css';
import propTypes from 'prop-types';

class CountryPanel extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  static propTypes = {
    continents: propTypes.array.isRequired
  };

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const { continents } = this.props;
    return (
      <div>
        <div className={styles.expander} onClick={this.toggleExpand}>
          <span className={styles.textWrapper}>
            Browse Speedtest Awards by Country{'    '}
            <svg onClick={() => this.toggleExpand()} className="svg-icon ">
              <svg dangerouslySetInnerHTML={{ __html: caret }} />
            </svg>
          </span>
        </div>
        {this.state.expanded ? <CountryList continents={continents} /> : null}
      </div>
    );
  }
}

export default CountryPanel;
